<template>
  <div :id="'windrose-chart' + id"></div>
</template>

<script>
import Highcharts from "highcharts";
import More from "highcharts/highcharts-more";
import Exporting from "highcharts/modules/exporting";
import ExportData from "highcharts/modules/export-data";  

More(Highcharts);

export default {
  props: {
    chart: Object,
    id: {
      type: String,
      default: "1",
    },
    exporting: {
      type: Boolean,
      default: true,
    },
    exportData: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    if (props.exporting) {
      Exporting(Highcharts);
    }
    if (props.exportData) {
      ExportData(Highcharts);
    }
  },
  data() {
    return {
      HChart: null,
    };
  },
  mounted() {
    this.createChart();
  },
  updated() {
    console.log("updated");
  },
  methods: {
    createChart() {
      console.log("createChart", this.chart);
      this.HChart = Highcharts.chart("windrose-chart" + this.id, this.chart);

      // resize chart
      const ro = new ResizeObserver((entries) => {
        this.HChart.reflow();
      });
      ro.observe(document.getElementById("windrose-chart" + this.id));
    },
  },
  watch: {
    chart: {
      handler(newValue, oldValue) {
        console.log("redraw chart", this.chart);
        this.HChart.update(this.chart);

        // Note: `newValue` will be equal to `oldValue` here
        // on nested mutations as long as the object itself
        // hasn't been replaced.
      },
      deep: true,
    },
  },
};
</script>

<style>
</style>